var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00390625H513V341.989H0V-0.00390625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00390625H513V113.993H0V-0.00390625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 227.992H513V341.989H0V227.992Z",
    fill: "#268024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 170.999L0 341.994V-0.00976562L256.5 170.999Z",
    fill: "#E4312B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPs);
export default __webpack_public_path__ + "static/media/PS.8a3d94bf7b0197c94a1ad440a10c8d28.svg";
export { ForwardRef as ReactComponent };